const rooster = {
  optionsButton: {
    position: 'absolute',
    zIndex: 100,
    right: '-20px',
    top: '34px',
    color: '#fff',
    fontSize: '30px',
    fontWeight: 'bold',
    lineHeight: '1.3',
  },
  attachIcon: {
    display: 'inline-block',
    height: '50px',
    width: '50%',
    position: 'relative',
    top: '4px',
    userSelect: 'none',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    lineHeight: '56px',
  },
}

module.exports = rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/MessageOptionsButton.js